export const ApiDateFormat = 'yyyy-MM-dd HH:mm:ss.SSSS';
export const ApiTimeZone = 'UTC';
export const RegularDateFormat = 'MMM d, yyyy | HH:mm:ss';
export const RegularDateFormatMMMdyyyy = 'MMM d, yyyy';
export const RegularDateFormatMMMdy = 'MMM d, y | H:mm';
export const RegularDateFormatMMMddyyy = 'MMM dd, yyyy | HH:mm';
export const RegularDateFormatdMMMyyyy = 'd MMM  yyyy';
export const MonthYearFormat = 'MMMM, yyyy';
export const Epoch = '1 January 1970, 00:00:00 UTC';
export const BEEpoch = '1970-01-01 00:00:00';
export const ShortDate = 'HH:mm MMM d, yyyy';
export const LongDateFormatForSheetName = 'MMM d, yyyy HH_mm_ss';
export const DateFormatddMMyyyy = 'dd.MM.yyyy';
export const DateFormatMMMdyy = 'MMM d, yy';
export const DateFormatdMMMyyyy = 'd MMM, yyyy';

export function isEpoch(strDate: string): boolean {
  return Date.parse(strDate) === 0 || strDate === BEEpoch;
}
